/* tslint:disable */
/* eslint-disable */
/**
 * Main data new API
 * Auto-generated openapi scheme for main-data-new API
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ReadOnlyCurrencyConversionSerializer
 */
export interface ReadOnlyCurrencyConversionSerializer {
    /**
     * 
     * @type {string}
     * @memberof ReadOnlyCurrencyConversionSerializer
     */
    id?: string;
    /**
     * 
     * @type {number}
     * @memberof ReadOnlyCurrencyConversionSerializer
     */
    readonly deleted?: number;
    /**
     * 
     * @type {string}
     * @memberof ReadOnlyCurrencyConversionSerializer
     */
    currencyOrigin: string;
    /**
     * 
     * @type {string}
     * @memberof ReadOnlyCurrencyConversionSerializer
     */
    currencyForeign: string;
    /**
     * 
     * @type {Date}
     * @memberof ReadOnlyCurrencyConversionSerializer
     */
    date: Date;
    /**
     * 
     * @type {number}
     * @memberof ReadOnlyCurrencyConversionSerializer
     */
    rate: number;
    /**
     * 
     * @type {Date}
     * @memberof ReadOnlyCurrencyConversionSerializer
     */
    readonly createdAt?: Date;
}

export function ReadOnlyCurrencyConversionSerializerFromJSON(json: any): ReadOnlyCurrencyConversionSerializer {
    return ReadOnlyCurrencyConversionSerializerFromJSONTyped(json, false);
}

export function ReadOnlyCurrencyConversionSerializerFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReadOnlyCurrencyConversionSerializer {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'deleted': !exists(json, 'deleted') ? undefined : json['deleted'],
        'currencyOrigin': json['currency_origin'],
        'currencyForeign': json['currency_foreign'],
        'date': (new Date(json['date'])),
        'rate': json['rate'],
        'createdAt': !exists(json, 'created_at') ? undefined : (new Date(json['created_at'])),
    };
}

export function ReadOnlyCurrencyConversionSerializerToJSON(value?: ReadOnlyCurrencyConversionSerializer | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'currency_origin': value.currencyOrigin,
        'currency_foreign': value.currencyForeign,
        'date': (value.date.toISOString()),
        'rate': value.rate,
    };
}


